import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { Modal } from "react-bootstrap";
import EmailBlacklistCreateViewModel from "viewModels/administration/emailBlacklist/emailBlacklistCreateViewModel";
import CreateView from "../../common/create";
import EmailBlacklistForm from "./emailBlacklistForm";

const EmailBlacklistCreateView: ViewComponent<EmailBlacklistCreateViewModel> = observer(({ vm }) => (
  <Modal scrollable show={true} onHide={vm.requestClose} centered>
    <Modal.Body>
      <CreateView vm={vm} titleClassName="text-left" form={<EmailBlacklistForm vm={vm} isCreate={true} />} />
    </Modal.Body>
  </Modal>
));

registerView(EmailBlacklistCreateView, EmailBlacklistCreateViewModel);
